import { Video } from './video';

export class Playlist {
  public PlaylistId = '';
  public PlaylistActive = false;
  public PlaylistDescription = '';
  public PlaylistSiteId = '';
  public PlaylistSiteName = '';
  public PlaylistCreationDate = '';
  public PlaylistTitle = '';
  public PlaylistUrl = '';
  public PlaylistVideos: Video[] = [];

  constructor() { }

  public static parse(data: any): Playlist {
    const playlist = new Playlist();

    if (data) {
      if (data.PlaylistId) {
        playlist.PlaylistId = data.PlaylistId;
      }
      if (data.PlaylistActive || data.PlaylistActiva) {
        playlist.PlaylistActive = data.PlaylistActive || data.PlaylistActiva;
      }
      if (data.PlaylistDescription || data.PlaylistDescripcion) {
        playlist.PlaylistDescription = data.PlaylistDescription || data.PlaylistDescripcion;
      }
      if (data.PlaylistSiteId || data.PlaylistSitioId) {
        playlist.PlaylistSiteId = data.PlaylistSiteId || data.PlaylistSitioId;
      }
      if (data.PlaylistSiteName || data.PlaylistSitioNombre) {
        playlist.PlaylistSiteName = data.PlaylistSiteName || data.PlaylistSitioNombre;
      }
      if (data.PlaylistTitle || data.PlaylistTitulo) {
        playlist.PlaylistTitle = data.PlaylistTitle || data.PlaylistTitulo;
      }
      if (data.PlaylistCreationDate || data.PlaylistFechaCreada) {
        playlist.PlaylistCreationDate = data.PlaylistCreationDate || data.PlaylistFechaCreada;
      }
      if (data.PlaylistUrl) {
        playlist.PlaylistUrl = data.PlaylistUrl;
      }
      if (
        (data.PlaylistVideos && data.PlaylistVideos.length > 0) ||
        (data.Videos && data.Videos.length > 0)
      ) {
        if (data.PlaylistVideos && data.PlaylistVideos.length > 0) {
          data.PlaylistVideos.forEach(v => playlist.PlaylistVideos.push(Video.parse(v.VideoData)));
        } else if (data.Videos && data.Videos.length > 0) {
          data.Videos.forEach(v => playlist.PlaylistVideos.push(Video.parse(v.VideoData)));
        }
      }
    }

    return playlist;
  }
}
